import { api, type ProjectView } from '../../lib/client.ts';
import { PipelinePlaces } from '../pipelines/pipeline-places.tsx';

/**
 * The project's Pipelines card (TS-1748): the shared `PipelinePlaces` over the project's routes.
 * Upsell/Crossell can move while Sales stays at Won; a won or lost place can be archived.
 */
export function ProjectPipelines({
  project,
  canWrite,
  onChanged,
}: {
  project: ProjectView;
  canWrite: boolean;
  onChanged: () => Promise<void>;
}) {
  return (
    <PipelinePlaces
      type="project"
      recordName={project.name}
      places={project.pipelines}
      canWrite={canWrite}
      onChanged={onChanged}
      testId="project-pipelines"
      placeTestId="project-pipeline"
      actions={{
        move: (stageId) => api.projects.patch(project.id, { stageId }),
        setArchived: (pipelineId, archived) =>
          archived
            ? api.projects.archiveInPipeline(project.id, pipelineId)
            : api.projects.restoreInPipeline(project.id, pipelineId),
        add: (body) => api.projects.addToPipeline(project.id, body),
      }}
    />
  );
}
